import { createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import {
  selectIsCardToAddWithMultipleImages,
  selectSelectedCardTypeToAdd,
  selectUserIdToAddCardFor,
} from '../selectors/cards.selectors';
import { getCardImageUploadSignedUrl } from '../services/getCardImageUploadSignedUrl.service';
import { postAddCardForUser } from '../services/postAddCardForUser.service';
import { compressCardImage } from '../utils/compressCardImage.util';

export const addCardForOtherUser = createAsyncThunk(
  'cards/addCardForOtherUser',
  async (cardData, { getState }) => {
    const userIdOfOtherUserToAddCardFor = selectUserIdToAddCardFor(getState());

    const selectedCardType = selectSelectedCardTypeToAdd(getState());

    const isMultipleImages = selectIsCardToAddWithMultipleImages(getState());

    const isCustomCompetencyCardType = selectedCardType.includes(
      'CUSTOM_BUSINESS_COMPETENCY'
    );

    const cardType = isCustomCompetencyCardType
      ? selectedCardType.split('#')[0]
      : selectedCardType;

    const cardName = isCustomCompetencyCardType
      ? selectedCardType.split('#')[1]
      : undefined;

    const { cardAttributes, cardImage, cardImage2 } = cardData;

    const compressedImage = cardImage
      ? await compressCardImage(cardImage)
      : undefined;

    const compressedImage2 = isMultipleImages && cardImage2
      ? await compressCardImage(cardImage2)
      : undefined;

    const effectiveIsMultipleImages = Boolean(
      isMultipleImages && compressedImage && compressedImage2
    );

    const cardUserId = userIdOfOtherUserToAddCardFor;

    if (!cardUserId) {
      console.log('Error: User id not provided to add card for');
    }

    const cardToPost = {
      ...cardAttributes,
      userId: cardUserId,
      type: cardType,
      name: cardName,
      isMultipleImages: effectiveIsMultipleImages,
      imageCount: effectiveIsMultipleImages ? 2 : undefined,
    };

    const fileType = compressedImage?.type;
    const fileType2 = compressedImage2?.type;

    const imageUploadSignedUrl = compressedImage
      ? await getCardImageUploadSignedUrl(
          cardUserId,
          cardAttributes.id,
          fileType
        )
      : undefined;

    const imageUploadSignedUrl2 = effectiveIsMultipleImages
      ? await getCardImageUploadSignedUrl(
          cardUserId,
          `${cardAttributes.id}_2`,
          fileType2
        )
      : undefined;

    if (imageUploadSignedUrl && compressedImage) {
      const options = {
        headers: {
          'Content-Type': fileType,
        },
      };

      await Axios.put(imageUploadSignedUrl, compressedImage, options);
    }

    if (imageUploadSignedUrl2 && compressedImage2) {
      const options = {
        headers: {
          'Content-Type': fileType2,
        },
      };

      await Axios.put(imageUploadSignedUrl2, compressedImage2, options);
    }

    const response = await postAddCardForUser(cardToPost);

    return response;
  }
);
